import { forwardRef } from 'react';
import type { ElementType } from 'react';

import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import type { Theme, SxProps } from '@mui/material/styles';

import { RouterLink } from 'src/routes/components';

// ----------------------------------------------------------------------

type Props = {
  disabledLink?: boolean;
  size?: number | string;
  sx?: SxProps<Theme>;
};

const Logo = forwardRef<HTMLAnchorElement, Props>(({ disabledLink = false, size = 40, sx, ...other }, ref) => {
  const logo = (
    <Box component="img" src="/assets/icons/logo.png" sx={{ width: size, height: size, cursor: 'pointer', ...sx }} />
  );

  if (disabledLink) return logo;
  // TODO: tighten — RouterLink requires `href`, but this pre-existing code renders it
  // without one (react-router receives `to={undefined}` at runtime).
  return (
    <Link component={RouterLink as ElementType} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

export default Logo;
